// Copyright: IQGeo Limited 2010-2019
import $ from 'jquery';
import _ from 'underscore';
import Backbone from 'backbone';
import myw from 'myWorld/base/core';
import L from 'leaflet';
import layerControlHtml from 'text!html/layerControl.html';
import 'jquery-ui';
import 'jquery-ui-touch';
import './layerControlSubLayer';

const layerGroupHtml = $(layerControlHtml)
    .filter('#layer-group-template')
    .html();

myw.LayerControlGroup = Backbone.View.extend({
    innerTemplate: _.template(layerGroupHtml),
    events: {
        'click .relative': 'toggleCheckbox',
        'click .layer-group-select': 'updateSelection',
        'click .layer-list-delete': 'remove',
        'click .expandLayerGroup': 'toggleExpandedState',
        subLayerSelect: '_autoUpdateGroupState'
    },
    /**
     * @class Creates a view to display the layer groups
     * @param  {LayerControl}  options.control
     * @param  {layerListGroup}    options.model
     * @constructs
     * @extends {Backbone.View}
     */
    initialize(options) {
        this.model = options.model;
        this.control = options.control;
        this.expanded = this.model.expanded || false;
        this.render();
    },

    render() {
        this.setElement(
            this.innerTemplate(_.extend({ baseUrl: myw.baseUrl, thumbnail: null }, this.model))
        ); // Creates the group header
        this.checkbox = this.$('.layer-group-select');
        this.addSubLayers();
        this.expandLayerGroup();
    },

    /**
     * Creates views for the subLayers and adds them to the group's sub-layer-container
     */
    addSubLayers() {
        this.subLayers = [];
        let subLayerView;

        _.each(this.model.subLayers, subLayer => {
            const layer = this.control.layerManager.getLayer(subLayer.layerDef.id);

            subLayerView = new myw.LayerControlSubLayer({
                control: this.control,
                groupView: this,
                group: this.model,
                layer: layer,
                model: subLayer,
                description: this.control.layerManager.getLayerItemDescription(subLayer.layerDef)
            });
            this.$('.sub-layer-container').append(subLayerView.el);

            this.subLayers.push(subLayerView);
        });
        this._autoUpdateGroupState();
    },

    toggleCheckbox() {
        this.checkbox.click();
    },

    /**
     * Handles the checkbox click on the layer group
     */
    updateSelection(ev) {
        if (!this.isEditMode) {
            this.setLayerChecked();

            ev.stopPropagation(); //so the click on expand button is not bubbled up to the row which adds the layer to the panel
        }
    },

    /**
     * Asks the layerManager to make the group visible is its checkbox is checked and vice versa
     * Called it setLayerChecked so it can be called by the layerControl on layerRow as well as groupRow
     */
    setLayerChecked() {
        let checked = this.checkbox.prop('checked');

        // When clicking on an indeterminate checkbox, IE and Edge change it to checked whereas other browsers uncheck it
        // We want the uncheck behaviour
        if ((L.Browser.ie || L.Browser.edge) && this.isIndeterminate) {
            checked = false;
        }

        this.model.turned_on = checked;

        this.control.layerManager.setGroupChecked(this.model.layer_name, checked);

        _.each(
            this.subLayers,
            layerView => {
                layerView.setDisabled(); //Update the disabled state of the subLayers
            },
            this
        );
    },

    /**
     * Sets the groups checkbox to checked, unchecked or indeterminate according to its layers' state.
     * @param {boolean} checked  Whether the subLayer that triggered the subLayerSelect event is turnedOn or not.
     * @private
     */
    _autoUpdateGroupState() {
        const subLayersStateArray = []; // stores the checked state of subLayers

        _.each(this.model.subLayers, layer => {
            subLayersStateArray.push(layer.turned_on);
        });

        this._setCheckboxState(subLayersStateArray);
    },
    /**
     * Sets the state of the tri-state group checkbox
     * @param {array<boolean>} subLayersStateArray Array with the checked state of all the subLayers
     * @private
     */
    _setCheckboxState(subLayersStateArray) {
        const groupSelectBox = this.checkbox;
        const isGroupTurnedOn = this.model.turned_on;

        if (
            _.contains(subLayersStateArray, true) &&
            _.contains(subLayersStateArray, false) &&
            isGroupTurnedOn
        ) {
            //Indeterminate
            this.isIndeterminate = true;
            groupSelectBox.prop('indeterminate', true).prop('checked', true);
        } else if (
            _.contains(subLayersStateArray, true) &&
            !_.contains(subLayersStateArray, false) &&
            isGroupTurnedOn
        ) {
            //Checked
            this.isIndeterminate = false;
            groupSelectBox.prop('indeterminate', false).prop('checked', true);
        } else {
            //Unchecked
            this.isIndeterminate = false;
            groupSelectBox.prop('indeterminate', false).prop('checked', false);
        }
    },

    /**
     * Expands the layer group is this.expanded is true
     */
    expandLayerGroup() {
        this.$('.sub-layer-container').toggleClass('hidden', !this.expanded);
        this.$('.expandLayerGroup').toggleClass('expanded', this.expanded);
    },

    /**
     * Expands the layer group if it was collapsed and vice versa
     * @param  {object} ev Click event
     */
    toggleExpandedState(ev) {
        ev.stopPropagation(); //so the click on expand button is not bubbled up to the row which adds the layer to the panel
        this.$('.sub-layer-container').toggle();
        this.$('.expandLayerGroup').toggleClass('expanded');
        this.expanded = !this.expanded;
        this.control.layerManager.updateGroupExpandedState(this.model.layer_name, this.expanded);
    },

    /**
     * Updates the group's checkbox
     * @param  {boolean} checked State that needs to be assigned to the group's checkbox
     */
    checkCheckbox(checked) {
        this.checkbox.prop('checked', checked);
        this.model.turned_on = checked; // Updates the model
        this._autoUpdateGroupState();
    },

    /**
     * Removes the layer from the list and from the map
     */
    remove(ev) {
        this.$el.remove();
        this.control.removeGroup(this);
    },
    enable() {
        this.checkbox.prop('disabled', false);
    },
    disable() {
        this.checkbox.prop('disabled', true);
    }
});
export default myw.LayerControlGroup;
